/**
 * @copyright   OnlyOneProd © 2025
 * @authors     Jonathan COULLET <contact@onlyoneprod.com>
 * @link        https://onlyoneprod.com
 * @notice      All information contained herein is,
 *              and remains the property of OnlyOneProd and its suppliers,
 *              Any dissemination of this information or reproduction
 *              of this material is strictly forbidden unless prior
 *              written permission is obtained from OnlyOneProd.
 */

export const consentGoogleAnalytics = () => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('consent', 'update', {
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'ad_storage': 'granted',
            'analytics_storage': 'granted'
        });
    } else {
        console.warn('Google Analytics not loaded or not defined');
    }
};

export const trackButtonClick = (eventName: string) => {
    sendGoogleAnalyticsEvent(eventName, 'Button', 'Button click');
};

export const trackFormSubmit = (eventName: string) => {
    sendGoogleAnalyticsEvent(eventName, 'Button', 'Form submit');
};

const sendGoogleAnalyticsEvent = (name:string, category:string, label:string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', name, {
            event_category: category,
            event_label: label,
        });
    } else {
        console.warn('Google Analytics not loaded or not defined');
    }
};